/* Source: /home/sidsolaiyappan/skooch_ai/shared/chat_usage_compute.jac */
import {__jacJsx, __jacSpawn} from "@jac/runtime";
function computeChatUsageFromProfile(profile) {
  if (!profile) {
    return {"unlimited": false, "used": 0, "limit": 10};
  }
  if (profile.onboarding_completed) {
    return {"unlimited": true, "used": 0, "limit": 10};
  }
  let today = Reflect.construct(Date, []).toISOString().slice(0, 10);
  let storedDate = (profile.chat_messages_today_date ? profile.chat_messages_today_date : "");
  let storedCount = (profile.chat_messages_today ? profile.chat_messages_today : 0);
  let used = ((storedDate === today) ? Math.trunc(Number(storedCount)) : 0);
  return {"unlimited": false, "used": used, "limit": 10};
}
export {computeChatUsageFromProfile};
//# sourceMappingURL=chat_usage_compute.js.map
